import React, { useState, useEffect } from "react";
import { TextField, CircularProgress } from "@mui/material";
import { EditGratitudeApi } from "../../DAL/Gratitude/Gratitude";
import { useSnackbar } from "notistack";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { s3baseUrl } from "../../config/config";

export default function EditGratitude({ editData, onCloseDrawer, dataList }) {
  const { enqueueSnackbar } = useSnackbar();
  const [previews, setPreviews] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = React.useState("");
  const [state, setState] = useState({
    gratitudeDescription: "",
    gratitudeId: "",
  });

  const handleRemove = () => {
    setPreviews("");
    setImage("");
  };

  const handleUpload = (event) => {
    const fileList = event.target.files;
    setImage(event.target.files[0]);
    const preview = URL.createObjectURL(event.target.files[0]);
    setPreviews(preview);
  };

  //Adding Category

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (image === "" && previews === "") {
      enqueueSnackbar("Image is required", { variant: "error" });
      setIsLoading(false);
    } else {
      const formData = new FormData();
      formData.append("gratitude_text", state.gratitudeDescription);
      if (image) {
        formData.append("image", image);
      }
      const result = await EditGratitudeApi(state.gratitudeId, formData);
      if (result.code === 200) {
        onCloseDrawer();
        dataList();
        setIsLoading(false);
        enqueueSnackbar(result.message, { variant: "success" });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      ["gratitudeDescription"]: editData.pinterestDescription,
      ["gratitudeId"]: editData.pinteres_id,
    }));
    setPreviews(s3baseUrl + editData.pinterestImage);
  }, [editData]);

  return (
    <>
      <div className="container new-memories">
        <form onSubmit={handleSubmit}>
          <TextField
            className="mt-4"
            id="outlined-multiline-static"
            label="Gratitude Description"
            multiline
            rows={5}
            name="gratitudeDescription"
            value={state.gratitudeDescription}
            variant="outlined"
            style={{ width: "100%" }}
            required={true}
            onChange={(e) => handleChange(e)}
          />
          <p className="mt-4 mb-0">Recommended Size (1000x670)</p>
          <div className="col-md-12 mt-2 d-flex">
            {previews && (
              <span className="preview mt-2">
                <span onClick={handleRemove}>x</span>
                <img src={previews} />
              </span>
            )}
            {previews == "" && (
              <span className="upload-button mt-2">
                <input
                  color="primary"
                  accept="image/*"
                  type="file"
                  id="icon-button-file"
                  style={{ display: "none" }}
                  name="affirmationImage"
                  onChange={handleUpload}
                />
                <label htmlFor="icon-button-file">
                  <CloudUploadIcon />
                </label>
              </span>
            )}
          </div>
          <div className="text-end mt-3">
            <button className="submit-button" disabled={isLoading}>
              {isLoading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
